export default __webpack_public_path__ + "static/media/clearcut.608a6c1a.svg";